<h2 mat-dialog-title>Edit Price Tier</h2>

<mat-dialog-content class="mat-typography">
    <div class="price-tier-form-container">
        @if (priceTierForm) {
        <form [formGroup]="priceTierForm">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Tier</mat-label>
                        <input
                            matInput
                            formControlName="tier"
                            placeholder="Enter tier number"
                        />
                        @if (priceTierForm.get('tier')?.hasError('required')) {
                        <mat-error>
                            Tier is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Effective From</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker"
                            [min]="currentDate"
                            formControlName="effective_from"
                            placeholder="Enter effective from date"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if
                        (priceTierForm.get('effective_from')?.hasError('required'))
                        {
                        <mat-error>
                            Effective From is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Operative Cost</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="operative_cost"
                            placeholder="Enter operative cost"
                        />
                        <span matPrefix>£&nbsp;</span>
                        @if
                        (priceTierForm.get('operative_cost')?.hasError('required'))
                        {
                        <mat-error>
                            Operative cost is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Subcontractor Cost</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="subcontractor_cost"
                            placeholder="Enter subcontractor cost"
                        />
                        <span matPrefix>£&nbsp;</span>
                        @if
                        (priceTierForm.get('subcontractor_cost')?.hasError('required'))
                        {
                        <mat-error>
                            Subcontractor cost is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Material Cost</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="material_cost"
                            placeholder="Enter material cost"
                        />
                        <span matPrefix>£&nbsp;</span>
                        @if
                        (priceTierForm.get('material_cost')?.hasError('required'))
                        {
                        <mat-error>
                            Material cost is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Sell Price</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="sell_price"
                            placeholder="Enter sell price"
                        />
                        <span matPrefix>£&nbsp;</span>
                        @if
                        (priceTierForm.get('sell_price')?.hasError('required'))
                        {
                        <mat-error>
                            Sell price is required
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </form>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">
        Save
    </button>
</mat-dialog-actions>
